import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedCompanyMappingService } from '@wealthlane/api-services/wealthlane-identity-service';
import {
  ProcedureService,
  Wealthlane_CustomerService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useDeleteSandbox = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_Response_ResponseDto | undefined,
  unknown,
  string,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: string) => {
      return await handleRequest(ProcedureService.deleteApiCustomerApiAppProcedureSandboxData(id));
    },
    {
      onSuccess: async () => {
        toast.success(<ToastComponent label='Success' message={`Sandbox delete job submitted.`} />);
        await queryClient.invalidateQueries('getSwitchSandboxList');
        onClose && onClose();
      },
      onError: (err) => {
        onClose && onClose();
        console.log('error', err);
      },
    }
  );
};

export default useDeleteSandbox;
